document.addEventListener('DOMContentLoaded', function () {
  const description = document.querySelector('.product__text');
  if (!description) return;

  // Intro-Absätze vor der ersten h2/h3 einwickeln
  const firstHeading = description.querySelector('h2, h3');
  if (firstHeading) {
    const introWrapper = document.createElement('div');
    introWrapper.classList.add('accordion-intro');
    let node = description.firstElementChild;
    while (node && node !== firstHeading) {
      const next = node.nextElementSibling;
      introWrapper.appendChild(node);
      node = next;
    }
    if (introWrapper.children.length > 0) {
      description.insertBefore(introWrapper, firstHeading);
    }
  }

  // Akkordeon für alle h2/h3
  const headings = description.querySelectorAll('h2, h3');
  headings.forEach(function (heading) {
    const content = [];
    let next = heading.nextElementSibling;
    while (next && !['H2', 'H3'].includes(next.tagName)) {
      content.push(next);
      next = next.nextElementSibling;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('accordion-content');
    heading.after(wrapper);
    content.forEach(el => wrapper.appendChild(el));

    heading.addEventListener('click', function () {
      const isOpen = wrapper.classList.contains('accordion-open');
      wrapper.classList.toggle('accordion-open', !isOpen);
      heading.classList.toggle('accordion-open', !isOpen);
    });
  });
});
